import { AdBaseData } from './useAdBaseData';
import { useRelatedAds } from '@/hooks/useRelatedAds';
import { AdStatus } from '@/types';
import { Shop } from '@/api/types/common.types';

export function useAdRelatedData(
  adBaseData: AdBaseData,
  isAuthor: boolean,
  visibleShop: Shop | null
) {
  const { relatedAds, loading: relatedAdsLoading } = useRelatedAds();

  const relatedAdsList = relatedAds?.nodes ?? [];
  const { Published } = AdStatus;
  const isBrowser = typeof window !== 'undefined';
  const { status, currentCategory } = adBaseData;
  const hasVisibleShop = Boolean(visibleShop);
  const isRelatedAdsVisible =
    (status === Published || !isAuthor) &&
    (relatedAdsList.length > 0 || relatedAdsLoading || !isBrowser);
  const relatedAdsHasNextPage = !!relatedAds?.pageInfo?.hasNextPage;
  const hasShowAllLink =
    (hasVisibleShop && status === Published) || relatedAdsHasNextPage;
  const currentCategoryPath = currentCategory?.path ?? '';
  const relatedAdsShowAllLink = hasShowAllLink
    ? hasVisibleShop && status === Published
      ? visibleShop?.uri
      : currentCategoryPath
      ? `/${currentCategoryPath}`
      : undefined
    : undefined;

  return {
    relatedAdsList,
    relatedAdsLoading,
    isRelatedAdsVisible,
    hasShowAllLink,
    relatedAdsShowAllLink,
    hasVisibleShop,
  };
}
